@if (config) {
  <div
    class="alert"
    [ngClass]="{
      success: config?.type === 'success',
      error: config?.type === 'error',
      info: config?.type === 'info',
      warning: config?.type === 'warning'
    }"
  >
    <div class="content">
      <div>
        @switch (config?.type) {
          @case ("success") {
            <mat-icon>task_alt</mat-icon>
          }
          @case ("error") {
            <mat-icon>error</mat-icon>
          }
          @case ("warning") {
            <mat-icon>warning</mat-icon>
          }
          @default {
            <mat-icon>info</mat-icon>
          }
        }
      </div>
      <div class="text">
        <span class="title">{{ config.title || "" | translate }}</span>
        <span class="sub-title">{{ config.subtitle || "" | translate }}</span>
      </div>
    </div>
    @if (config?.closeIcon) {
      <mat-icon class="close" (click)="onDismiss()">close_circle </mat-icon>
    }
  </div>
}
